import { useCallback } from 'react';
import { Linking } from 'react-native';
import { useFetchOld } from 'hooks';
import InAppBrowser from 'utils/packages/inAppBrowser';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../constants';
import { postLiveSheetGoogleOAuth2, } from './actions';
import { openPopup, makeWebRedirectUri } from './util';
const REDIRECT_URI = isWeb
    ? makeWebRedirectUri()
    : 'emma://live-sheet/callback';
export function useAuthorizeInGoogle() {
    const [, , doingPostGoogleOAuth2, doPostGoogleOAuth2] = useFetchOld();
    const authorizeInGoogle = useCallback(async () => {
        const payload = await doPostGoogleOAuth2(postLiveSheetGoogleOAuth2(REDIRECT_URI));
        if (payload) {
            const { authUrl } = payload;
            if (isWeb) {
                openPopup(authUrl);
                return;
            }
            if (!(await InAppBrowser.isAvailable())) {
                await Linking.openURL(authUrl);
                return;
            }
            let responseInAppBrowser;
            try {
                responseInAppBrowser = await InAppBrowser.openAuth(authUrl, REDIRECT_URI, {
                    // iOS
                    ephemeralWebSession: false,
                    // Android
                    showTitle: false,
                    enableUrlBarHiding: true,
                    enableDefaultShare: false,
                });
            }
            catch {
                await Linking.openURL(authUrl);
                return;
            }
            if (responseInAppBrowser.type !== 'success') {
                return;
            }
            await Linking.openURL(responseInAppBrowser.url); // back to APP
        }
    }, [doPostGoogleOAuth2]);
    return {
        authorizeInGoogle,
        isAuthorizing: doingPostGoogleOAuth2,
    };
}
export function useHandleLiveExportGoogleOAuthCallback() {
    const navigation = useMainStackNavigation();
    return useCallback((url) => {
        if (isWeb) {
            return false;
        }
        if (url.startsWith(REDIRECT_URI)) {
            navigation.navigate('ExportDataLiveTransit', {
                enableIfAuthenticated: true,
            });
            return true;
        }
        return false;
    }, []);
}
